import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "container",
  ref: "tv"
}
const _hoisted_3 = {
  key: 0,
  class: "container__header"
}
const _hoisted_4 = { class: "container__body" }
const _hoisted_5 = {
  key: 0,
  class: "container__body__status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "overlay" }, null, -1)),
      (_ctx.hasHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.hasHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "header")
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 512)
  ]))
}